module.exports = __webpack_public_path__ + "static/media/ZWZ Slewing Bearing_compressed.05ca6bef.pdf";